import {SetQuery} from '@pluto/set-history-query';
import {History} from 'history';

import {
    OnNumberSetState,
    OnInputChangeEvent,
} from '@pluto/@types';
import {
    SetUsersAction,
    UsersState,
    UserRolesEnum,
    UserStatusEnum,
    UserListFilterParams,
} from '@pluto/users';

export type OnSearch = (e: OnInputChangeEvent) => void;

export enum UserFiltersKeys {
    Roles = 'roles',
    Status = 'status',
}

export interface UserListFilters {
    roles?: UserRolesEnum[];
    status?: UserStatusEnum[];
}

export type SetUserListQuery = SetQuery<UserListFilters>;

export interface UserListFiltersHandlers extends UserListFilterParams {
    history: History;
    route: string;
    setFilters: React.Dispatch<React.SetStateAction<UserListFilters>>;
    setQuery: SetUserListQuery;
    setPage: OnNumberSetState;
    getList: SetUsersAction;
    key: UserFiltersKeys;
}

export interface UserListStateProps {
    users: UsersState;
}

export interface UserListDispatchProps {
    setUsers: SetUsersAction;
}

export type UserContainerProps = UserListStateProps & UserListDispatchProps;
